import { render, staticRenderFns } from "./recipe-cna-register.vue?vue&type=template&id=c12a9ffc&scoped=true&"
import script from "./recipe-cna-register.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-register.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-register.vue?vue&type=style&index=0&id=c12a9ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a9ffc",
  null
  
)

export default component.exports